module.exports = __webpack_public_path__ + "static/28invgde-51c3b731ac3a2a27b9e9b235d0369898.gif";